<template>
  <a-modal
    title="修改记录变更"
    :visible="visible"
    :mask-closable="false"
    :width="1000"
    :confirm-loading="loading"
    destroy-on-close
    :footer="null"
    @cancel="handleCancel"
  >
    <a-table
      :columns="columns"
      :data-source="initData"
      :loading="loading"
      :pagination="false"
      style="padding: 16px 0; background-color: #fff;"
      :row-key="(item, index) => item.operatorTime ? item.operatorTime + index: index"
    >
      <template
        slot="operateTime"
        slot-scope="text, record"
      >
        {{ moment(record.operatorTime).format('YYYY-MM-DD HH:mm:ss') }}
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    detailData: {
      type: Array,
      default: null
    },
    resourceId: {
      type: String,
      default: null
    },
    initData: {
      type: Array,
      default: null
    }
  },

  data () {
    return {
      form: {
        baseId: '',
        collectionAmount: '',
        collectionDate: '',
        operateYear: ''
      },
      loading: false,
      columns: [
        {
          title: '操作时间',
          dataIndex: 'operateTime',
          key: 'operateTime',
          width: '160px',
          scopedSlots: { customRender: 'operateTime' }
        },
        {
          title: '操作人',
          dataIndex: 'operatorName',
          key: 'operatorName',
          width: '180px'
        },
        {
          title: '操作前内容',
          dataIndex: 'before',
          key: 'before'
        },
        {
          title: '操作后内容',
          dataIndex: 'after',
          key: 'after'
        }
      ]
    }
  },
  methods: {
    moment,
    handleCancel () {
      this.$emit('cancel')
    }
  }
}
</script>
